import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import axios from 'axios';
import { TILE_REGISTRY } from './Favourite/TileRegistry'; 
import PinToHome from './Favourite/PinToHome'; 
import { MASTER_API } from '../apiConfig';
import { getCurrentUser } from '../utils/getCurrentUser';

function Cable() {
  const [savedTiles, setSavedTiles] = useState([]);

  const currentUser = getCurrentUser();
  const displayName = JSON.parse(localStorage.getItem("user"))?.firstName || "User";

  useEffect(() => {
    if (currentUser) {
      axios.get(`${MASTER_API}/favorites/${currentUser}`)
        .then(res => {
          const fetchedIds = res.data.favorites;

          const tiles = fetchedIds
            .map(id => TILE_REGISTRY[id])
            .filter(tile => tile !== undefined);

          setSavedTiles(tiles);
        })
        .catch(console.error);
    }
  }, [currentUser]);

  const handleNavigate = (path) => {
    window.location.href = path;
  };

  return (
    <Layout>
      <div style={{ padding: "30px 40px", backgroundColor: "#f8fafc", minHeight: "calc(100vh - 60px)" }}>
        
        {/* --- Page Header --- */}
        <div style={{ marginBottom: "35px" }}>
            <h2 style={{ margin: "0 0 8px 0", color: "#0f172a", fontWeight: "700", fontSize: "28px" }}>
            Welcome back
            </h2>
            <p style={{ color: "#64748b", margin: 0, fontSize: "15px" }}>
            Here is your personalized quick-access dashboard.
            </p>
        </div>

        {/* --- Empty State --- */}
        {savedTiles.length === 0 ? (
          <div style={{ 
              textAlign: "center", 
              padding: "60px 20px", 
              background: "#ffffff",
              border: "2px dashed #cbd5e1", 
              borderRadius: "16px", 
              color: "#94a3b8",
              boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)"
          }}>
            <div style={{ fontSize: "48px", marginBottom: "15px", color: "#e2e8f0" }}>📌</div>
            <h4 style={{ color: "#475569", fontWeight: "600", marginBottom: "10px" }}>No shortcuts pinned yet</h4>
            <p style={{ fontSize: "14px" }}>Navigate to any module and click the Star (★) icon to pin it to your dashboard.</p>
          </div>
        ) : (
          /* --- Single Grid Render (Horizontal Flow) --- */
          <div style={{ 
              display: "grid", 
              gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", 
              gap: "24px" 
          }}>
            {savedTiles.map((item, i) => {
              const IconComp = item.icon;
              return (
                <div
                  key={i}
                  style={{
                    background: "#ffffff", 
                    borderRadius: "16px", 
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)",
                    padding: "24px", 
                    cursor: "pointer", 
                    position: "relative",
                    display: "flex", 
                    flexDirection: "column",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    height: "160px"
                  }}
                  onClick={() => handleNavigate(item.path)}
                  onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-6px)";
                      e.currentTarget.style.boxShadow = "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)";
                      e.currentTarget.style.borderColor = "#cbd5e1";
                  }}
                  onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)";
                      e.currentTarget.style.borderColor = "#e2e8f0";
                  }}
                >
                  {/* Top Row: Icon + Pin Button */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "auto" }}>
                      {/* Tinted Icon Box */}
                      <div style={{ 
                          background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)", 
                          color: "#3b82f6", 
                          padding: "14px", 
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                      }}>
                          <IconComp size={26} />
                      </div>
                      
                      {/* Pin Button for Unpinning */}
                      <div style={{ position: "relative", zIndex: 10, marginTop: "-5px", marginRight: "-5px" }}>
                          <PinToHome tileId={item.id} />
                      </div>
                  </div>

                  {/* Bottom Row: Text */}
                  <div>
                      <h5 style={{ fontSize: "16px", fontWeight: "600", color: "#0f172a", margin: "0 0 6px 0" }}>
                        {item.name}
                      </h5>
                      <p style={{ fontSize: "13px", color: "#64748b", margin: 0, fontWeight: "500" }}>
                        Open Module <span style={{ marginLeft: "4px", fontSize: "14px" }}>→</span>
                      </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Cable;